export enum LabelPlacement {
  TOP_LEFT = "Top Left",
  TOP_CENTER = "Top Center",
  TOP_RIGHT = "Top Right",
  CENTER_LEFT = "Center Left",
  CENTER = "Center",
  CENTER_RIGHT = "Center Right",
  BOTTOM_LEFT = "Bottom Left",
  BOTTOM_CENTER = "Bottom Center",
  BOTTOM_RIGHT = "Bottom Right",
}

export const COVER_LABELS_INSTRUCTION = "Cover existing labels";
